import * as React from 'react';

import { useHiddenMessagePhones } from './useHiddenMessagePhones';
import { trackHiddenMessagePhoneClick } from '../tracking';
import { EMessageType } from '../../../types/messageType';
import { TMessage } from '../../../types/messages';

interface IUseMessageTextProps {
  message: TMessage;
  messageId: string;
  messageType: EMessageType;
  chatId: string;
}

export const useMessageText = ({ message, messageId, messageType, chatId }: IUseMessageTextProps) => {
  const { userId, communicationId, offers, message: text } = message;
  const offer = offers?.[0];

  const isOutcoming = messageType === EMessageType.Outcoming;

  const hiddenMessagePhonesClick = React.useCallback(() => {
    trackHiddenMessagePhoneClick({
      chatId,
      messageId,
      offerId: offer?.realtyOfferId,
      communicationId,
    });
  }, [chatId, communicationId, messageId, offer?.realtyOfferId]);

  const { replacePhoneNumbers } = useHiddenMessagePhones({
    messageUserId: userId,
    isOutcoming,
    onClick: hiddenMessagePhonesClick,
  });

  return React.useMemo(() => {
    const trimmedText = text?.trim();

    if (!trimmedText) {
      return null;
    }

    return trimmedText.split('\n').map((item, key) => (
      <span key={`text-${key}`}>
        {replacePhoneNumbers(item)}
        <br />
      </span>
    ));
  }, [replacePhoneNumbers, text]);
};
